import axios from "axios";
import { defineStore } from "pinia";

export const useSelfVitals = defineStore("selfVitals", {
  state: () => ({
    errors: null,
    loaderStatus: false,
    vitalsData: "",
    latestVitalData: "",
    filterData: ""
  }),
  getters: {
    getErrors: (state) => {
      return state.errors;
    },
    getLoaderStatus: (state) => {
      return state.loaderStatus;
    },
    getVitalsData: (state) => {
      return state.vitalsData;
    },
    getLatestVitalData: (state) => {
      return state.latestVitalData
    }
  },
  actions: {
    async getVitals() {
      try {
        this.setErrors(null)
        this.loaderStatus = true;
        await axios
          .get("/patient_vitals")
          .then((response) => {
            this.loaderStatus = false;

            this.vitalsData = response.data.data.patient_vitals;
            this.latestVitalData = response.data.data.patient_vitals[0];
          })
          .catch((error) => {
            this.setErrors(error.response.data)
            this.loaderStatus = false;
          });
      } catch (error) {
        this.loaderStatus = false
      }
    },
    setErrors(error) {
      this.errors = error;
    }
  },
  
});
